import React from 'react';
import {
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  InputLabel
} from '@mui/material';
import { useField } from 'formik';
import { ArrowDropDown } from '@mui/icons-material';

// Self = 1,
// Spouse = 2,
// Child = 3,
// Other = 4
const options = [
  {
    id: 1,
    value: 'Self'
  },
  {
    id: 2,
    value: 'Spouse'
  },
  {
    id: 3,
    value: 'Child'
  },
  {
    id: 4,
    value: 'Other'
  }
];
const DropdownIcon = props => {
  return <ArrowDropDown {...props} />;
};
export const InsuredRelationshipToPatientField = ({ name, ...props }) => {
  const [field] = useField({
    name
  });

  return (
    <FormControl
      variant="outlined"
      style={{
        backgroundColor: 'white'
      }}
    >
      <InputLabel
        htmlFor="form-select"
        sx={{
          '&.MuiFormLabel-root.MuiInputLabel-shrink': {
            background: 'linear-gradient(#f5f5f5 50%, white 50%)'
          }
        }}
      >
        Insured Relation to Patient
      </InputLabel>
      <Select
        id="insured-relationship-to-insurance"
        data-cy="insured-relationship-to-insurance"
        labelId="insured-relationship-to-insurance"
        style={{
          minWidth: '206px',
          height: '50px'
        }}
        inputProps={{
          style: {
            padding: '22px 16px 8px'
          }
        }}
        IconComponent={props => {
          console.log(props);
          return <DropdownIcon {...props} />;
        }}
        input={<OutlinedInput />}
        {...field}
        {...props}
      >
        <MenuItem
          value={''}
          style={{ height: '36px' }}
          data-cy={'option-id-0'}
        ></MenuItem>
        {options.map(option => {
          return (
            <MenuItem
              key={option.id}
              value={option.id}
              style={{ height: '36px' }}
              data-cy={`option-id-${option.id}`}
            >
              {option.value}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
